import { types, type Instance } from 'mobx-state-tree';
export const MatchedQuality = types.model('MatchedQuality', {
  id: types.string,
  displayLabel: types.string,
  isTop: types.boolean,
  relevanceScore: types.number,
});
export interface IMatchedQuality extends Instance<typeof MatchedQuality> {}

export const MatchedQualities = types.model('MatchedQualities', {
  qualities: types.maybeNull(types.array(MatchedQuality)),
  hasError: types.optional(types.boolean, false),
});

export interface IMatchedQualities extends Instance<typeof MatchedQualities> {}
